/**
 * Created by kyle-ssg on 10/02/15.
 */
export default {
  'LOGIN': 'LOGIN',
  'LOGOUT': 'LOGOUT',
  'REGISTER': 'REGISTER',
  'RESET_PASSWORD': 'RESET_PASSWORD',
  'SET_TOKEN': 'SET_TOKEN',
  'SET_USER': 'SET_USER',
}
